import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <div>
        <section className="bg-gray-100/50 py-20 lg:py-28 max-md:pt-[120px]">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* Section Header */}
            <div className="text-center">

              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2"  data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Data Privacy
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl" data-aos="fade-up" data-aos-delay={100}>
                Privacy Policy
              </h2>
            </div>

            <div className="theme-container mx-auto mt-[40px]" data-aos="fade-up" data-aos-delay={200}>
              <div className="w-full">
                <div className="container">
                  <div className="services-details-items">
                    <div className="row">
                      <div className="col-xl-12 services-single-content">
                        <p>
                          OPD Cover (OPD Cover”, “we”, “us”, or “our”) respects
                          the privacy of our users (“you” or “your”). This Privacy
                          Policy describes how we collect, use, disclose, and
                          protect your personal information when you access and use
                          our website (the “Website”) and our SaaS-based healthtech
                          infrastructure (the “Service”).
                        </p>
                        <p>
                          <strong>1. Information We Collect</strong>
                        </p>
                        <p>
                          We collect several types of information from and about you
                          when you use the Website and Service:
                        </p>
                        <div>
                          <p>
                            <strong>Personal Information:</strong> This includes
                            information that can be used to identify you directly,
                            such as your name, email address, phone number, and
                            postal address. We may collect this information when you
                            create an account, contact us, or use certain features
                            of the Service.
                          </p>
                          <p>
                            <strong>Usage Data:</strong> We collect information
                            about your activity on the Website and Service, such as
                            the pages you visit, the features you use, and the time
                            you spend on the Website and Service.
                          </p>
                          <p>
                            <strong>Device Information:</strong> We collect
                            information about the device you use to access the
                            Website and Service, such as your device type, operating
                            system, browser type, IP address, and device
                            identifiers.
                          </p>
                          <p />
                        <p>
                          <strong> Health &amp; Fitness Data:</strong> Our app
                          accesses and collects the following health and fitness data
                          through Android Health Connect (Google Health Connect):
                        </p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>
                            <strong>a) Step Count:</strong> We access your daily step
                            count to display your physical activity progress within
                            the app.
                          </p>                          <p>
                            b) Our app accesses and collects the following health and fitness data through{" "}
                            <strong>Apple HealthKit (iOS)</strong> and <strong>Android Health Connect (Google Health Connect):</strong>
                          </p>
                          <p>
                            <strong>c) How we use this data:</strong> To display your
                            daily step count and progress toward your personal fitness
                            goal within the app interface.
                          </p>
                          <p>
                            <strong>d) Data Storage:</strong> Step count data is
                            processed locally on your device and is not transmitted to
                            our servers or stored externally.
                          </p>
                          <p>
                            <strong>e) Data Sharing:</strong> We do not sell, share, or
                            transfer your health or fitness data to any third parties.
                          </p>
                          <p>
                            <strong>f) Your Control:</strong> You can revoke HealthKit permissions at any time{" "}
                            <strong>
                               via iOS Settings → Privacy & Security → Health → Opdcover, or revoke Health Connect permissions via Android Settings → Health Connect → App permissions → Opdcover.
                            </strong>
                            .
                          </p>
                          </div>
                        </div>
                        <p>
                          <strong> Vitals via Face Scan:</strong> Our app offers an optional "Vitals via Face Scan" feature that estimates certain physiological metrics using your device's camera.
                        </p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>
                            <strong>a) What we collect:</strong> During a scan, the camera captures a live video preview for approximately 30 seconds. We use on-device face detection (Google ML Kit) solely to guide face positioning during the scan. We then analyze subtle color changes in small areas of your face (forehead and cheeks) using a standard signal-processing technique (remote photoplethysmography, or rPPG) to estimate heart rate, breathing rate, blood oxygen level, stress indicator, and — combined with your entered height and weight — BMI.
                          </p>
                          <p>
                            <strong>b) What we do NOT collect or store:</strong> We do not capture, save, or transmit any facial image, video recording, or biometric facial template. All camera frames are processed transiently in memory during the scan and are discarded immediately afterward.
                          </p>
                          <p>
                            <strong>c) What is sent to our servers:</strong> Only the final computed numeric results (heart rate, breathing rate, blood oxygen %, stress level, BMI, and timestamp) are sent to our servers and stored as part of your personal health record, so you can view your scan history within the app.
                          </p>
                          <p>
                            <strong>d) Data retention:</strong> This data is retained for as long as you maintain an active account with us, so you can access your historical vitals records. You may request deletion at any time as described in Section 10.
                          </p>
                          <p>
                            <strong>e) Data sharing:</strong> We do not sell, share, or transfer this data to any third party.
                          </p>
                          <p>
                            <strong>f) Your control:</strong> This feature is entirely optional and only activates when you choose to start a scan.
                          </p>
                        </div>
                        {/* <p>
                          <strong> AI Diet Plan:</strong> If you use our AI Diet Plan feature, the age, height, weight, and gender you provide are sent to Anthropic (the provider of the Claude AI service) solely to generate your personalized diet plan, including meal suggestions and daily nutrition targets. This data is transmitted only when you choose to use this feature and only after you provide explicit consent. Anthropic processes this data in accordance with its own privacy and data-use terms. This feature and any associated diet plan history is included with your OPD Cover plan at no additional charge.
                        </p> */}
                        <p>
                          <strong> Health & Wellness Disclaimer:</strong> The health and wellness features in our app (including camera-based wellness scans, health assessments, and AI-generated diet plans) are intended for general informational and wellness purposes only. They are not medical devices, do not provide medical diagnoses, and are not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of a qualified physician regarding any medical condition.
                        </p>
                        <p>
                          <strong> Health Assessment:</strong> Our app offers optional self-assessed wellness questionnaires (e.g., Physical Health, Diet & Nutrition, Heart Health). Your answers generate a wellness score based on predefined point values; this is not an AI-based or diagnostic assessment. Your responses and score are stored as part of your health record for as long as you maintain an active account, and are not shared with any third party. This feature is included with your OPD Cover plan at no additional charge.
                        </p>
                        <p>
                          <strong>2. How We Use Your Information</strong>
                        </p>
                        <p>We use your information to:</p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>- Provide and operate the Website and Service</p>
                          <p>- Process your requests and transactions</p>
                          <p>
                            - Send you important information about the Website and
                            Service, including updates, security alerts, and support
                            messages
                          </p>
                          <p>
                            - Communicate with you about your use of the Website and
                            Service
                          </p>
                          <p>- Monitor and improve the Website and Service</p>
                          <p>
                            - personalize your experience on the Website and Service
                          </p>
                          <p>- Comply with legal and regulatory requirements</p>
                        </div>
                        <p>
                          <strong>3. Disclosure of Your Information</strong>
                        </p>
                        <p>
                          We may disclose your information to third-party service
                          providers who help us operate the Website and Service.
                          These service providers are obligated to protect your
                          information and are only permitted to use it for the
                          purposes we instruct them.
                        </p>
                        <p>
                          We may also disclose your information if we are required
                          to do so by law or in the good faith belief that such
                          disclosure is necessary to:
                        </p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>Comply with a legal process</p>
                          <p>
                            Protect the rights or safety of you, Saayaa, or
                            others
                          </p>
                        </div>
                        <p>
                          <strong>4. Data Retention</strong>
                        </p>
                        <p>
                          We will retain your information for as long as your
                          account is active or as needed to provide you with the
                          Website and Service. We may also retain your information
                          for legal, regulatory, and audit purposes.
                        </p>
                        <p>
                          <strong>5. Your Choices</strong>
                        </p>
                        <p>You have certain choices regarding your information:</p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>
                            You can access and update your personal information
                            through your account settings.
                          </p>
                          <p>
                            You can unsubscribe from our marketing communications by
                            following the unsubscribe instructions in those
                            communications.
                          </p>
                        </div>
                        <p>
                          <strong>6. Security</strong>
                        </p>
                        <p>
                          We take reasonable steps to protect your information from
                          unauthorized access, disclosure, alteration, or
                          destruction. However, no internet transmission or
                          electronic storage is 100% secure.
                        </p>
                        <p>
                          <strong>7. Children’s Privacy</strong>
                        </p>
                        <p>
                          The Website and Service are not directed to children under
                          the age of 18. We do not knowingly collect personal
                          information from children under 18. If you are a parent or
                          guardian and you believe your child has provided us with
                          personal information, please contact us.
                        </p>
                        <p>
                          <strong>8. International Transfers</strong>
                        </p>
                        <p>
                          Your information may be transferred to and processed in
                          countries other than your own. These countries may have
                          different data protection laws than your own country.
                        </p>
                        <p>
                          <strong>9. Changes to this Privacy Policy</strong>
                        </p>
                        <p>
                          We may update this Privacy Policy from time to time. We
                          will post the updated Privacy Policy on the Website. You
                          are advised to review this Privacy Policy periodically for
                          any changes.
                        </p>
                        <p>
                          <strong>10. Data Deletion</strong>
                        </p>
                        <p>
                          Users have the right to request deletion of their personal
                          data.
                        </p>
                        <p className="pl-2">
                          a. You can request data deletion by: contacting us at:{" "}
                          <p className="font-semibold inline">info@opdcover.com</p>
                        </p>
                        <p className="pl-2">b. Once we receive your request:</p>
                        <p className="pl-4">
                          i. We will delete your data within 7–30 days
                        </p>
                        <p className="pl-4">
                          ii. Some data may be retained if required by law or for
                          legitimate business purposes
                        </p>
                        <p>
                          <strong>11. Contact Us</strong>
                        </p>
                        <p>
                          If you have any questions about this Privacy Policy,
                          please contact us at info@opdcover.com.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </>

  );
};

export default PrivacyPolicy;
